import { render, staticRenderFns } from "./ProductsBox.vue?vue&type=template&id=66484101&"
import script from "./ProductsBox.vue?vue&type=script&lang=js&"
export * from "./ProductsBox.vue?vue&type=script&lang=js&"
import style0 from "./ProductsBox.vue?vue&type=style&index=0&id=66484101&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports